import Axios, { InternalAxiosRequestConfig } from 'axios';

import { env } from '@/config/env';

const TOKEN_KEY = 'authtoken';
// トークンを取得する実装
export const getToken = () => {
  console.info('api-client.ts_1');
  return localStorage.getItem(TOKEN_KEY);
};

// トークンの保存
export const setToken = (token: string) => {
  console.info('api-client.ts_2');
  localStorage.setItem(TOKEN_KEY, token);
};

// トークンの削除
export const removeToken = () => {
  console.info('api-client.ts_3');
  localStorage.removeItem(TOKEN_KEY);
};

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  console.info('api-client.ts_4');

  if (config.headers) {
    console.info('api-client.ts_5');

    config.headers.Accept = 'application/json';

    const token = getToken();
    if (token) {
      console.info('api-client.ts_6');

      config.headers['Authorization'] = `Bearer ${token}`;
      console.log('Sending request with token:', token); // デバッグ用
    } else {
      console.info('api-client.ts_7');

      console.log('No token found'); // デバッグ用
    }
  }
  console.info('api-client.ts_8');

  config.withCredentials = true;
  return config;
}

export const api = Axios.create({
  baseURL: env.API_URL,
  paramsSerializer: { indexes: null },
});

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
  (response) => {
    console.info('api-client.ts_11');

    return response.data;
  },
  (error) => {
    console.info('api-client.ts_12');

    if (
      error.response?.status === 401 &&
      !window.location.pathname.includes('/auth/')
    ) {
      console.info('api-client.ts_13');

      const tenantSlug = window.location.pathname.split('/')[1];
      console.info('api-client.ts_15');
      if (window.location.pathname.includes('/app/document/')) {
        console.info('api-client.ts_16');
        const redirect = window.location.pathname.substring(
          `/${tenantSlug}/`.length,
        );
        window.location.href = `/${tenantSlug}/auth/login?redirect=${redirect}`;
      } else {
        console.info('api-client.ts_17');
        window.location.href = `/${tenantSlug}/auth/login`;
      }
    }
    console.info('api-client.ts_18');

    return Promise.reject(error);
  },
);
